var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.IsMobile)?_c('Carousel2'):[_c('Carousel'),_c('Conteudo')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }